import React, { FC } from "react";
import { Skeleton as MuiSkeleton, SkeletonProps } from "@mui/material";

const Skeleton: FC<SkeletonProps> = (props) => <MuiSkeleton {...props} />;

export default Skeleton;
